// This component wraps a component intended to be a Launch Darkly consumer via the withLDConsumer function
import React from 'react';
import { useLDClient, withLDConsumer } from 'launchdarkly-react-client-sdk';

function LaunchDarklyWrapper({ children, flags }) {
  /* If we do not block rendering of the rest of the application before loading, any LD gated cards will transition in after the rest of the page loads.
   *  Assuming we want a smoother transition, we will delay rendering until Launch Darkly is configured and connected.
   * */

  const LDClient = useLDClient();
  if (!LDClient || LDClient.isLoading) return null;

  const childrenWithFlags = React.cloneElement(children, { flags });
  return childrenWithFlags;
}

export default withLDConsumer()(LaunchDarklyWrapper);
